import { useState } from 'react';
import { KhachHang, TaiKhoan } from '@/types/schemas';

export interface UseSearchFieldStatesReturn {
  account: TaiKhoan | null;
  setAccount: (account: TaiKhoan | null) => void;
  customer: KhachHang | null;
  setCustomer: (customer: KhachHang | null) => void;
}

export function useSearchFieldStates(): UseSearchFieldStatesReturn {
  const [account, setAccount] = useState<TaiKhoan | null>(null);
  const [customer, setCustomer] = useState<KhachHang | null>(null);

  return {
    account,
    setAccount,
    customer,
    setCustomer
  };
}
